import { __decorate, __metadata } from "tslib";
import { CacheActivePromise } from '@1inch-community/core/decorators';
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { getShadowDomElement, observe } from '@1inch-community/core/lit-utils';
import { OverlayViewMode } from '@1inch-community/models';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
import { defer, map } from 'rxjs';
import '../shared-elements/address-view';
import '../shared-elements/balance-view';
import { connectWalletViewStyle } from './connect-wallet-view.style';
import './wallet-manager-route.element';
let ConnectWalletViewElement = class ConnectWalletViewElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
        this.overlayId = null;
        this.chainId$ = defer(() => this.getWalletController().data.chainId$);
        this.activeAddress$ = defer(() => this.getWalletController().data.activeAddress$);
        this.info$ = defer(() => this.getWalletController().data.info$);
        this.icon$ = this.info$.pipe(map((item) => item.icon));
        this.name$ = this.info$.pipe(map((item) => item.name));
        this.view$ = defer(() => this.getWalletController().data.isConnected$).pipe(map((isConnected) => {
            return isConnected ? this.getConnectedView() : this.getConnectWalletButton();
        }));
    }
    static { this.tagName = 'inch-connect-wallet-view'; }
    static { this.styles = connectWalletViewStyle; }
    render() {
        return html `${observe(this.view$)}`;
    }
    /**
     * Component like a ConnectButton
     * @private
     */
    getConnectedView() {
        return html `
      <div
        class="connect-wallet-view-container"
        @click="${() => this.mobileView && this.onManagerRouteView()}"
      >
        <img
          class="connect-wallet-view-icon"
          alt="${observe(this.name$)}"
          src="${observe(this.icon$)}"
        />
        ${when(!this.mobileView, () => html `
            <inch-wallet-total-fiat-balance
              .address="${observe(this.activeAddress$)}"
            ></inch-wallet-total-fiat-balance>
            <inch-button @click="${() => this.onManagerRouteView()}" type="secondary" size="m">
              <inch-address-view
                hideTooltip
                address="${observe(this.activeAddress$)}"
              ></inch-address-view>
            </inch-button>
          `)}
      </div>
    `;
    }
    getConnectWalletButton() {
        return html `
      <inch-button
        @click="${() => this.onManagerRouteView()}"
        type="${this.mobileView ? 'primary-gray' : 'secondary'}"
        size="${this.mobileView ? 'l' : 'xl'}"
      >
        ${when(this.mobileView, () => html ` <inch-icon icon="wallet24"></inch-icon>`, () => html `<span>Connect wallet</span>`)}
      </inch-button>
    `;
    }
    getWalletController() {
        return this.applicationContext.value.wallet;
    }
    async onManagerRouteView() {
        if (this.applicationContext.value.overlay.isOpenOverlay(this.overlayId)) {
            await this.closeCurrentOverlay();
            return;
        }
        this.overlayId = await this.applicationContext.value.overlay.open(html `
        <inch-wallet-manager-route
          mobileView="${ifDefined(this.mobileView ? '' : undefined)}"
          @closeCard="${() => {
            if (!this.overlayId) {
                return;
            }
            this.closeCurrentOverlay();
        }}"
        ></inch-wallet-manager-route>
      `, { targetFactory: () => getShadowDomElement('swap-form'), mode: OverlayViewMode.auto });
    }
    async closeCurrentOverlay() {
        if (this.overlayId) {
            await this.applicationContext.value.overlay.close(this.overlayId);
            this.overlayId = null;
        }
    }
};
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Boolean)
], ConnectWalletViewElement.prototype, "mobileView", void 0);
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ConnectWalletViewElement.prototype, "onManagerRouteView", null);
ConnectWalletViewElement = __decorate([
    customElement(ConnectWalletViewElement.tagName)
], ConnectWalletViewElement);
export { ConnectWalletViewElement };
//# sourceMappingURL=connect-wallet-view.element.js.map